import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ceshi: null,
    user: null,
    userResult: null,
  },
  mutations: {
    setCeshi(state, val) {
      state.ceshi = val;
    },
    setUser(state, val) {
      state.user = val;
    },
    setUserResult(state, val) {
      state.userResult = val;
    },
  },
  actions: {

  }
})
